import { propSerializer } from 'ymodel'
import { TimeInterval } from '../TimeInterval'

propSerializer<TimeInterval, string>(TimeInterval, {
  deserialize: serialized => TimeInterval.parse(serialized),
  serialize:   interval   => interval.toString(),
})